import type { Campaign, Variant } from '@/api/types/graphql';
import { sortByConditions } from './sort';

export const mappingDataCampaign = (campaigns: Campaign[] | undefined): Campaign[] => {
  if (!campaigns) return [];
  return campaigns.map((campaign) => {
    const variants = (campaign.variants as Variant[]) || [];
    return {
      ...campaign,
      variants: sortByConditions<Variant>(variants, [{ attr: 'isOrigin' }]),
    };
  });
};
